
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhandardara() {



    const cardData =
    {
        keyword: 'Pune to Bhandardara Cabs',
        heading: 'Platinum24 Cabs: Pune to Bhandardara Cabs',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Bhandardara Cabs, perfect for weekend getaways, family picnics, and nature retreats. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey through the scenic Western Ghats. With professional chauffeurs, punctual service, and transparent pricing, we make your travel to Bhandardara’s famous spots like Arthur Lake, Randha Falls, and Wilson Dam completely hassle-free. Whether it’s a one-way trip, round-trip, or a group holiday, Platinum24 Cabs provides affordable fares, 24/7 availability, and dependable service for your Pune to Bhandardara journey.',

        top: 'Top Places to Visit in Bhandardara with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Arthur Lake",
    "description": "Arthur Lake, formed by the Pravara River, is Bhandardara’s most scenic attraction. Surrounded by lush green hills, it is perfect for boating, camping, and stargazing. Sunrises and sunsets here are breathtaking. Couples and families enjoy peaceful walks along the lakeside. Monsoon mist makes it even more enchanting. Arthur Lake is Bhandardara’s heart of natural beauty."
  },
  {
    "title": "Randha Falls",
    "description": "Randha Falls is a spectacular waterfall where the Pravara River plunges nearly 170 feet into a gorge. During monsoon, the falls thunder with immense force, creating a misty rainbow view. Viewpoints near the falls make it a favorite among photographers. The surrounding greenery adds to its charm. Pilgrims also consider it sacred. Randha Falls is Bhandardara’s dramatic natural wonder."
  },
  {
    "title": "Wilson Dam",
    "description": "Wilson Dam, built in 1910, is one of the oldest dams in India. It creates the beautiful Arthur Lake and supplies water to the region. The dam’s landscaped gardens are ideal for picnics. During monsoon, the dam gates open, creating mesmerizing cascades. It attracts tourists for both engineering marvel and natural beauty. Wilson Dam is Bhandardara’s century-old landmark."
  },
  {
    "title": "Umbrella Falls",
    "description": "Umbrella Falls, located below Wilson Dam, is a popular monsoon attraction. When the dam overflows, water gushes down creating an umbrella-like spray. A small footbridge lets tourists view the falls up close. It is one of the most photographed spots in Bhandardara. Families enjoy picnics nearby. Umbrella Falls is Bhandardara’s seasonal gem of monsoon magic."
  },
  {
    "title": "Kalsubai Peak",
    "description": "Kalsubai Peak, at 5,400 feet, is Maharashtra’s highest peak and a trekking paradise near Bhandardara. The trek is moderately challenging and offers panoramic views of the Sahyadris. A small temple of Kalsubai Devi stands at the summit. Monsoon treks are adventurous with mist and waterfalls. Trekkers enjoy sunrise treks for mesmerizing views. Kalsubai is Bhandardara’s crown jewel of adventure."
  },
  {
    "title": "Agastya Rishi Ashram",
    "description": "Agastya Rishi Ashram, on the banks of the Pravara River, is a serene spiritual retreat. Legends say Sage Agastya meditated here and released the river. Pilgrims visit the ashram for peace and blessings. The natural surroundings add to the spiritual aura. It is a quiet stop for meditation and reflection. The ashram is Bhandardara’s blend of mythology and tranquility."
  },
  {
    "title": "Ratangad Fort",
    "description": "Ratangad Fort, over 2,000 years old, overlooks Bhandardara and offers stunning views of hills and lakes. The trek to the fort passes through forests, caves, and waterfalls. The fort’s unique ‘Nedhe’ or natural hole in the rock is a highlight. Monsoon treks are adventurous and scenic. History and trekking lovers find it fascinating. Ratangad is Bhandardara’s heritage trek destination."
  },
  {
    "title": "Sandhan Valley (Valley of Shadows)",
    "description": "Sandhan Valley, near Bhandardara, is a deep canyon famous for trekking and rappelling adventures. Known as the Valley of Shadows, sunlight barely enters its depths. Trekkers experience thrilling descents, rock patches, and natural pools. Camping here under a starry sky is magical. It is a favorite among adventure seekers. Sandhan Valley is Bhandardara’s ultimate thrill spot."
  },
  {
    "title": "Amruteshwar Temple",
    "description": "Amruteshwar Temple, built in the 9th century, is an ancient Shiva temple near Bhandardara. Constructed in Hemadpanti style, it features intricate stone carvings and a serene ambiance. Surrounded by hills and streams, it is both spiritual and scenic. Devotees and history lovers admire its artistry. It is one of Maharashtra’s oldest temples. Amruteshwar is Bhandardara’s divine heritage treasure."
  },
  {
    "title": "Fireflies Festival",
    "description": "Bhandardara is famous for its magical Fireflies Festival held before monsoon in May–June. Thousands of fireflies illuminate the forests and villages at night, creating a fairyland effect. Camping organizers arrange night treks and stays to witness the glow. It is a favorite for couples, families, and photographers. The festival showcases nature’s wonder. Fireflies Festival is Bhandardara’s glowing night-time spectacle."
  }
],



     "services": [
    {
      "name": "Pune to Bhandardara Taxi Service",
      "description": "Travel comfortably from Pune to Bhandardara with our dedicated taxi service. Ideal for weekend getaways, nature trips, and pilgrimage visits, our taxis ensure a safe and pleasant journey through scenic routes. Our experienced drivers and well-maintained vehicles provide a hassle-free experience, allowing you to enjoy the beautiful landscapes without any stress. Choose from a variety of taxi options tailored to your group size and budget."
    },
    {
      "name": "Bhandardara Cab from Pune",
      "description": "Book a reliable Bhandardara cab from Pune for a smooth and timely journey. Whether you’re traveling solo, with family, or in groups, our cab service offers flexible pickup and drop timings to suit your itinerary. Our fleet includes sedans, SUVs, and tempo travellers for larger groups, ensuring a comfortable ride to your destination. Enjoy personalized service and transparent pricing when you travel with us."
    },
    {
      "name": "Pune Bhandardara Taxi Booking",
      "description": "Easily book your Pune to Bhandardara taxi through our seamless online or phone booking system. Get instant confirmation and competitive rates with no hidden charges. Our customer support team is available to assist you with customized travel plans, including sightseeing stops, meal breaks, and return trips. Experience convenience and peace of mind with our reliable booking process."
    },
    {
      "name": "Taxi Pune to Bhandardara",
      "description": "Our taxi service from Pune to Bhandardara offers an enjoyable and scenic journey through the Western Ghats. Perfect for nature lovers and adventure seekers, this route showcases waterfalls, hills, and serene lakes. Our professional drivers ensure timely pickups and safe navigation of the winding roads, making your trip memorable and comfortable."
    },
    {
      "name": "Bhandardara Cab Rental Pune",
      "description": "Rent a cab to Bhandardara from Pune with flexible packages for day trips, overnight stays, and multi-day tours. Our cab rental service offers competitive pricing and a variety of vehicle options, including air-conditioned cars and larger vans for group travel. Customize your rental duration and itinerary for an experience tailored to your preferences."
    },
    {
      "name": "Pune to Bhandardara Taxi Fare",
      "description": "Get transparent and affordable taxi fare estimates for Pune to Bhandardara trips. Our pricing includes all taxes, tolls, and driver allowances, ensuring no hidden costs. Whether you opt for a one-way journey or a round trip, enjoy competitive rates with premium service and comfortable vehicles."
    },
    {
      "name": "Bhandardara Private Taxi Pune",
      "description": "Enjoy the privacy and convenience of a private taxi from Pune to Bhandardara. Ideal for families, couples, and business travelers, our private taxis provide door-to-door service with flexible schedules and no detours. Travel at your own pace while enjoying the comfort and safety of our well-maintained cars."
    },
    {
      "name": "Bhandardara Cab Packages Pune",
      "description": "Choose from a variety of cab packages for Bhandardara trips departing from Pune. Packages include day trips, weekend getaways, and customized tours with sightseeing options. Benefit from fixed pricing, inclusive of driver costs and tolls, along with personalized itinerary planning to make the most of your visit."
    },
    {
      "name": "Pune to Bhandardara One Way Cab",
      "description": "Opt for our Pune to Bhandardara one way cab service for flexible travel plans. Perfect for those who want to explore Bhandardara and return by alternate means or stay longer, this option offers cost-effective and comfortable transport without the need for round-trip booking."
    },
    {
      "name": "Taxi Charges Pune to Bhandardara",
      "description": "Our taxi charges from Pune to Bhandardara are competitively priced to suit different budgets. Charges depend on vehicle type, travel duration, and distance. We ensure no surprise costs, with detailed fare breakdowns provided at the time of booking for complete transparency."
    },
    {
      "name": "Pune to Bhandardara Taxi Hire",
      "description": "Hire a taxi from Pune to Bhandardara with flexible options for half-day, full-day, or multiple-day hire. Our hire service accommodates leisure travelers, corporate clients, and group tours, providing professional drivers and comfortable vehicles throughout your journey."
    },
    {
      "name": "Bhandardara Weekend Trip Cab Pune",
      "description": "Plan a refreshing weekend trip to Bhandardara with our specially designed weekend cab packages from Pune. Enjoy relaxed travel schedules, stops at scenic spots, and dedicated driver services to ensure you have a memorable and hassle-free getaway."
    },
    {
      "name": "Pune Bhandardara Outstation Taxi",
      "description": "Our outstation taxi service from Pune to Bhandardara offers safe and convenient long-distance travel. Ideal for family outings and group excursions, we provide clean, well-maintained vehicles with courteous drivers familiar with the route and local attractions."
    },
    {
      "name": "Bhandardara Taxi with Driver Pune",
      "description": "Travel with ease using our Bhandardara taxi service with professional drivers based in Pune. Our drivers are experienced, courteous, and knowledgeable about the best routes, local customs, and safety measures, ensuring a pleasant and efficient journey."
    },
    {
      "name": "Taxi Service Pune to Bhandardara",
      "description": "Our taxi service from Pune to Bhandardara caters to all kinds of travelers, from solo adventurers to large families. With a wide range of vehicles, flexible booking options, and affordable rates, we aim to provide a seamless travel experience to one of Maharashtra’s most beautiful hill stations."
    }
  ],
  "tableData": [
    ["Pune to Bhandardara Taxi Service", "Bhandardara Cab from Pune"],
    ["Pune Bhandardara Taxi Booking", "Taxi Pune to Bhandardara"],
    ["Bhandardara Cab Rental Pune", "Pune to Bhandardara Taxi Fare"],
    ["Bhandardara Private Taxi Pune", "Bhandardara Cab Packages Pune"],
    ["Pune to Bhandardara One Way Cab", "Taxi Charges Pune to Bhandardara"],
    ["Pune to Bhandardara Taxi Hire", "Bhandardara Weekend Trip Cab Pune"],
    ["Pune Bhandardara Outstation Taxi", "Bhandardara Taxi with Driver Pune"],
    ["Taxi Service Pune to Bhandardara", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Comfortable Pune to Bhandardara Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs provides reliable and safe taxi services from Pune to the scenic Bhandardara getaway."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Bhandardara Route",
      "WhyChoosedescription": "Our skilled drivers ensure a smooth, timely, and enjoyable journey to Bhandardara."
    },
    {
      "WhyChooseheading": "Clean and Well-Maintained Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs for maximum comfort during your trip."
    },
    {
      "WhyChooseheading": "Flexible One-Way and Round Trip Booking Options",
      "WhyChoosedescription": "Choose packages based on your itinerary for convenience and flexibility."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Book your Pune to Bhandardara cab anytime with assistance from our dedicated support team."
    },
    {
      "WhyChooseheading": "Ideal for Family Trips, Group Outings, and Weekend Getaways",
      "WhyChoosedescription": "Perfect for leisure travel to the beautiful hills and lakes of Bhandardara."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options Available",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and tempo travellers to fit your group size and comfort."
    }
  ]
































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Bhandardara?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel from Pune to Bhandardara.',
    },
    {
        question: 'How can I book a Pune to Bhandardara cab with Platinum24 Cabs?',
        answer: 'You can book your Pune to Bhandardara cab easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Bhandardara trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and tempo travellers to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for the Pune to Bhandardara route?',
        answer: 'Yes, our drivers are professional, experienced, and knowledgeable about the Pune to Bhandardara route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Bhandardara?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Bhandardara cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Bhandardara rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Bhandardara route.',
    },
    {
        question: 'Are safety measures in place for Pune to Bhandardara cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Bhandardara travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Bhandardara?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Bhandardara routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Joshi',
        feedback: 'The Pune to Bhandardara cab service was excellent. The driver was punctual and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Kulkarni',
        feedback: 'I had a wonderful trip to Bhandardara with Platinum24 Cabs. The booking process was smooth and the service was top-notch.',
        rating: 5,
    },
];

























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const bhandardaraCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable taxi service from Pune to Bhandardara offering private cabs, outstation taxi bookings, weekend trip packages, and 24x7 taxi hire with experienced drivers.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "Pune to Bhandardara Taxi Service",
    "Bhandardara Cab from Pune",
    "Pune Bhandardara Taxi Booking",
    "Taxi Pune to Bhandardara",
    "Bhandardara Cab Rental Pune",
    "Pune to Bhandardara Taxi Fare",
    "Bhandardara Private Taxi Pune",
    "Bhandardara Cab Packages Pune",
    "Pune to Bhandardara One Way Cab",
    "Taxi Charges Pune to Bhandardara",
    "Pune to Bhandardara Taxi Hire",
    "Bhandardara Weekend Trip Cab Pune",
    "Pune Bhandardara Outstation Taxi",
    "Bhandardara Taxi with Driver Pune",
    "Taxi Service Pune to Bhandardara"
  ],
  "telephone": "+91-XXXXXXXXXX"
};







    return (
        <div>

<Helmet>
  <title>Pune to Bhandardara Cabs | Reliable Outstation Taxi Service</title>
  <meta
    name="description"
    content="Reliable and affordable taxi service from Pune to Bhandardara offering private cabs, outstation taxi bookings, weekend trip packages, and 24x7 taxi hire with experienced drivers."
  />
  <meta
    name="keywords"
    content="Pune to Bhandardara Taxi Service, Bhandardara Cab from Pune, Pune Bhandardara Taxi Booking, Taxi Pune to Bhandardara, Bhandardara Cab Rental Pune, Pune to Bhandardara Taxi Fare, Bhandardara Private Taxi Pune, Bhandardara Cab Packages Pune, Pune to Bhandardara One Way Cab, Taxi Charges Pune to Bhandardara, Pune to Bhandardara Taxi Hire, Bhandardara Weekend Trip Cab Pune, Pune Bhandardara Outstation Taxi, Bhandardara Taxi with Driver Pune, Taxi Service Pune to Bhandardara"
  />
  <script type="application/ld+json">
    {JSON.stringify(bhandardaraCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobhandardara;